import { faker } from '@faker-js/faker';

import {
  Avatar,
  Box,
  Chip,
  TableCell,
  TableRow
} from '@mui/material';
import { TaskStatusName } from 'generated/graphql';
import { DateTime } from 'luxon';
import { SaveTaskModal } from 'modules/components/layer17';
import React, { useState } from 'react';



export type TaskRowProps = {
  id: string;
  title: string;
  readableId: string;
  dueDate: DateTime | null;
  createdDate: DateTime;
  category: string;
  assignee: string;
  statusName: TaskStatusName;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: TaskRowProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  return (
    <>
      {isVisible && (
        <SaveTaskModal.FC
          id={props.id}
          isVisible
          handleClose={() => {
            setIsVisible(() => false);
          }}
        />
      )}
      <TableRow
        key={`row-${props.id}`}
        content='list'
        onClick={() => {
          setIsVisible(() => true);
        }}
      >
        <TableCell
          variant='firstRounded'
        >
          {props.readableId}
        </TableCell>
        <TableCell
          variant='body'
        >
          {props.title}
        </TableCell>
        <TableCell
          variant='body'
        >
          {props.dueDate ? props.dueDate.toFormat('LL-dd-yyyy') : '-'}
        </TableCell>
        <TableCell
          variant='body'
        >
          {props.createdDate.toFormat('LL-dd-yyyy')}
        </TableCell>
        <TableCell
          variant='body'
        >
          {props.category}
        </TableCell>
        <TableCell
          variant='body'
        >
          {props.assignee && (

            <Box
              display='flex'
              flexDirection='row'
              columnGap='.625rem'
              alignItems='center'
            >


              <Avatar
                variant='circular'
              />
              {props.assignee}
            </Box>
          )}

        </TableCell>
        <TableCell
          variant='body'
        >
          <Chip
            variant={faker.datatype.boolean(0.5)
              ? 'inProgressBlue'
              : 'delayed'}
            label={props.statusName}
          />
        </TableCell>

        <TableCell
          align='right'
          variant='lastRounded'
        >
          {/* <IconButton>
          <MoreVert />
          </IconButton> */}
        </TableCell>
      </TableRow>
    </>
  );


};
